import React from 'react';
import ReactDOM from 'react-dom';
import ClearPartnerPage from '../pages/ClearPartnerPage';

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <ClearPartnerPage />,
    document.body.appendChild(document.createElement('div')),
  )
});
